import type { AxiosRequestConfig } from 'axios'
import type {
  Perrito,
  StrapiPerritoData,
  StrapiPerritosResponse,
} from './types'
import { getRequest } from '../http'

// Function to map Strapi response to frontend format
function mapStrapiPerritoToPerrito(strapiData: StrapiPerritoData): Perrito {
  return {
    id: strapiData.documentId,
    name: strapiData.name,
    description: strapiData.description,
    price: strapiData.price,
    order: strapiData.order,
    image: strapiData.image.url,
  }
}

// API function to get perritos from Strapi
export async function getPerritos(axiosConfig?: AxiosRequestConfig): Promise<Perrito[]> {
  const response = await getRequest<StrapiPerritosResponse>(
    '/perritos?populate[image][fields][0]=url',
    axiosConfig,
  )

  if (!response?.data?.data || response?.data?.data?.length === 0) {
    return []
  }

  // Map all perritos and sort by order
  const perritos = response?.data?.data
    ?.map(mapStrapiPerritoToPerrito)
    ?.sort((a, b) => a.order - b.order)

  return perritos
}
